import React from 'react';
import Tooltip from 'components/Tooltip';
import { ConditionalWrapper } from 'utils/render';
import PropTypes from 'prop-types';

export const WrapWithToolTip = ({ children, hoverText }) => {
  const withTooltip = children => (
    <Tooltip displayIcon={false} text={hoverText}>
      {children}
    </Tooltip>
  );
  return (
    <ConditionalWrapper condition={hoverText} wrapper={withTooltip}>
      {children}
    </ConditionalWrapper>
  );
};

WrapWithToolTip.propTypes = {
  children: PropTypes.node,
  hoverText: PropTypes.string,
};
